import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule,HttpClientJsonpModule } from '@angular/common/http';
import { FormsModule,ReactiveFormsModule }   from '@angular/forms';



//Material
import { MaterialModule } from './material.module';
//InfiniteScroll
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
//FontAwesome
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
//ShareButtons
//import { ShareModule  } from '@ngx-share/core';
import { ShareButtonsModule } from '@ngx-share/buttons';
//Loaging Bar
import { LoadingBarModule } from '@ngx-loading-bar/core';
//App Routes
import { AppRoutingModule } from './app-routing.module';
//Services
import {ServicesModule} from './services/services.module';





@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FontAwesomeModule,
    LoadingBarModule,
    AppRoutingModule,
    HttpClientModule,
    HttpClientJsonpModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    ShareButtonsModule,
    LoadingBarModule,
    ServicesModule.forRoot(),

  ],
  exports: [
    MaterialModule,
    FontAwesomeModule,
    LoadingBarModule,
    AppRoutingModule,
    HttpClientModule,
    HttpClientJsonpModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    ShareButtonsModule,
    ServicesModule,
  ]
})
export class SharedModule { }
